const STORAGE_KEY = "sig_colors_v1";

type ColorMap = Record<string, string>;

function readAll(): ColorMap {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        return raw ? JSON.parse(raw) : {};
    } catch {
        return {};
    }
}

function persist(map: ColorMap): void {
    try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(map));
    } catch {
        // best effort
    }
}

function get(groupId: number | string): string | null {
    return readAll()[String(groupId)] ?? null;
}

function set(groupId: number | string, color: string | null): void {
    const map = readAll();

    if (color) {
        map[String(groupId)] = color;
    } else {
        delete map[String(groupId)];
    }

    persist(map);
}

export default { get, set };
